import layingImg from "../assets/services/laying.avif";
import lstImg from "../assets/services/lst.avif";
import civilImg from "../assets/services/civilengineering.avif";
import surveyImg from "../assets/services/surveying.avif";
import infraImg from "../assets/services/infrastructure.avif";

export const servicesDataEn = {
  "cable-laying": {
    title: "Cable Laying",
    number: "1",
    icon: "ph-lightning",
    image: layingImg,
    shortDesc:
      "Professional cable installation for power, signaling, and communication infrastructure.",
    overview: [
      "We provide cable installation and cable laying services for railway and infrastructure projects.",
      "Our teams execute safely, accurately, and in accordance with project specifications.",
    ],
    capabilities: [
      "Route planning and technical documentation",
      "Underground and surface cable installation",
      "Installation of power, data, and signaling cables",
      "Testing and commissioning",
    ],
  },
  lst: {
    title: "LST (Control & Safety Technology)",
    number: "2",
    icon: "ph-traffic-signal",
    image: lstImg,
    shortDesc:
      "Installation and modernization of railway signaling systems with LZB, PZB, and ETCS integration.",
    overview: [
      "We deliver complete LST solutions for regional and mainline railway networks.",
      "From installation to commissioning, we focus on operational safety and availability.",
    ],
    capabilities: [
      "Signaling system installation and maintenance",
      "LST cable laying and termination",
      "Integration of LZB, PZB, and ETCS",
      "Modernization of existing LST infrastructure",
    ],
  },
  "civil-engineering": {
    title: "Civil Engineering",
    number: "3",
    icon: "ph-hard-hat",
    image: civilImg,
    shortDesc:
      "Integrated railway engineering from planning to signaling and safety systems.",
    overview: [
      "We provide integrated engineering services for railway infrastructure projects.",
      "Our teams coordinate planning, assembly, and system integration to DB standards.",
    ],
    capabilities: [
      "Switch assembly and turnout installation",
      "Conversion and dismantling of signaling systems",
      "Technical adaptation of existing systems",
      "Planning of electronic systems for tracks and stations",
    ],
  },
  surveying: {
    title: "Surveying Technology",
    number: "4",
    icon: "ph-compass-tool",
    image: surveyImg,
    shortDesc:
      "Planning and commissioning of complex railway turnouts according to rail Standards.",
    overview: [
      "We provide precise surveying services for railway and infrastructure projects.",
      "Measurement accuracy and data integrity are ensured throughout all project phases.",
    ],
    capabilities: [
      "Control point and reference system setup",
      "Track axis positioning",
      "Quantity surveying and route alignment",
      "Surveying in constrained construction areas",
    ],
  },
  "cable-infrastructure": {
    title: "Cable Infrastructure",
    number: "5",
    icon: "ph-flow-arrow",
    image: infraImg,
    shortDesc:
      "Specialized underground cable civil works for railway, energy, and infrastructure networks.",
    overview: [
      "We execute cable civil works for railway and utility projects with high safety standards.",
      "From excavation to reinstatement, we deliver durable underground systems.",
    ],
    capabilities: [
      "Excavation and trench construction",
      "Duct and conduit installation",
      "Backfilling, compaction, and reinstatement",
      "Railway and utility interface coordination",
    ],
  },
};

export const servicesDataAr = {
  "cable-laying": {
    title: "مد الكابلات",
    number: "1",
    icon: "ph-lightning",
    image: layingImg,
    shortDesc:
      "تركيب الكابلات الاحترافي لبنية الطاقة والإشارات والاتصالات.",
    overview: [
      "نقدم خدمات تركيب الكابلات ومدها لمشاريع السكك الحديدية والبنية التحتية.",
      "تنفذ فرقنا العمل بأمان ودقة ووفقاً لمواصفات المشروع.",
    ],
    capabilities: [
      "تخطيط المسارات والتوثيق التقني",
      "تركيب الكابلات تحت الأرض وعلى السطح",
      "تركيب كابلات الطاقة والبيانات والإشارات",
      "الاختبار والتشغيل",
    ],
  },
  lst: {
    title: "LST (تقنية التحكم والسلامة)",
    number: "2",
    icon: "ph-traffic-signal",
    image: lstImg,
    shortDesc:
      "تركيب وتحديث أنظمة إشارات السكك الحديدية مع تكامل LZB وPZB وETCS.",
    overview: [
      "نقدم حلول LST متكاملة لشبكات السكك الحديدية الإقليمية والرئيسية.",
      "من التركيب إلى التشغيل، نركز على سلامة التشغيل والتوافر.",
    ],
    capabilities: [
      "تركيب وصيانة أنظمة الإشارات",
      "مد وتوصيل كابلات LST",
      "تكامل LZB وPZB وETCS",
      "تحديث البنية التحتية الحالية لـ LST",
    ],
  },
  "civil-engineering": {
    title: "الهندسة المدنية",
    number: "3",
    icon: "ph-hard-hat",
    image: civilImg,
    shortDesc:
      "هندسة متكاملة للسكك الحديدية من التخطيط إلى أنظمة الإشارات والسلامة.",
    overview: [
      "نقدم خدمات هندسية متكاملة لمشاريع البنية التحتية للسكك الحديدية.",
      "تنسق فرقنا التخطيط والتجميع وتكامل الأنظمة وفقاً لمعايير DB.",
    ],
    capabilities: [
      "تجميع المفاتيح وتركيب المحولات",
      "تحويل وتفكيك أنظمة الإشارات",
      "التكيف التقني للأنظمة الحالية",
      "تخطيط الأنظمة الإلكترونية للمسارات والمحطات",
    ],
  },
  surveying: {
    title: "تقنية المساحة",
    number: "4",
    icon: "ph-compass-tool",
    image: surveyImg,
    shortDesc:
      "تخطيط وتشغيل محولات السكك الحديدية المعقدة وفقاً لمعايير السكك الحديدية.",
    overview: [
      "نقدم خدمات مساحة دقيقة لمشاريع السكك الحديدية والبنية التحتية.",
      "يتم ضمان دقة القياس وسلامة البيانات في جميع مراحل المشروع.",
    ],
    capabilities: [
      "إعداد نقاط التحكم وأنظمة المرجع",
      "تحديد محاور المسار",
      "المسح الكمي ومحاذاة المسار",
      "المسح في مناطق البناء المقيدة",
    ],
  },
  "cable-infrastructure": {
    title: "البنية التحتية للكابلات",
    number: "5",
    icon: "ph-flow-arrow",
    image: infraImg,
    shortDesc:
      "أعمال مدنية متخصصة للكابلات تحت الأرض لشبكات السكك الحديدية والطاقة والبنية التحتية.",
    overview: [
      "ننفذ أعمال الكابلات المدنية لمشاريع السكك الحديدية والمرافق بمعايير سلامة عالية.",
      "من الحفر إلى الاستعادة، نقدم أنظمة تحت الأرض متينة.",
    ],
    capabilities: [
      "الحفر وإنشاء الخنادق",
      "تركيب القنوات والأنابيب",
      "الردم والدك والاستعادة",
      "تنسيق واجهة السكك الحديدية والمرافق",
    ],
  },
};

export default servicesDataEn;
